import type { ListBuilderList } from '../../../types';
import { createDefaultCompetitorColumns } from '../columns';

/**
 * Competitors added in the last 30 days, newest first, so a near-duplicate
 * ("Ferguson" beside "Ferguson Enterprises") is noticed and merged early.
 */
export const recentlyAddedCompetitorsList: ListBuilderList = {
	id: 'default-competitors-recent',
	cacheTTL: 600000,
	name: 'Recently Added',
	type: 'default',
	active: true,
	sortOrder: 3,
	columns: createDefaultCompetitorColumns(),
	description: 'Competitors added in the last 30 days',
	defaultSortId: 'created-desc',
	filterRules: {
		competitorRecentlyAdded: {
			defaultValue: [{ id: '30', label: 'Last 30 days' }],
			locked: true,
			hidden: true,
		},
	},
};
